import { marked } from "marked";

/**
 * We receive standard markdown string from the backend, which we need to parse to plain text.
 * Used to copy text to clipboard
 * @param html
 */
export const parseMDToText = (html: string): string => {
  const htmlText = marked(html);

  if (typeof htmlText === "string") {
    // Replace * with a newline
    const textWithNewlines = htmlText.replace(/\*/g, "\n");

    // Safe regular expression to remove HTML tags
    return textWithNewlines?.replace(/<[^>]*>/g, "");
  }

  return htmlText.toString();
};
